'use client'
import { memo, forwardRef, useState } from 'react'
import styled from 'styled-components'
import { mq, vw, getP18, rgbAlpha } from '@/styles'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface IFileUpload {
  name?: string,
  label: string,
  labelId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: UseFormRegisterReturn<any>,
  ref?: React.RefObject<HTMLInputElement>
}


export const FileUpload = memo<IFileUpload>(forwardRef(({ name = '', label, labelId, register = null}, ref) => {
  const [currentFile, setCurrentFile] = useState(label)

  const handleOnChange = (e) => {
    if(e.target.value) {
      setCurrentFile(e.target.value)
    } else {
      setCurrentFile(label)
    }
  }

  return (
    <Div className={currentFile === label ? '' : 'active'}>
      <Label htmlFor={labelId}>{currentFile}</Label>
      <Input type='file' id={labelId} name={name} ref={ref} {...(register && { ...register })} onChange={handleOnChange} />
    </Div>
  )
}))


const Div = styled.div`
  border-radius: ${vw(20, 'mobile')};
  border: 1px solid var(--color-black);
  color: var(--color-black);
  display: flex;
  height: ${vw(40, 'mobile')};
  margin-bottom: ${vw(55, 'mobile')};
  place-content: center;
  transition: 300ms background-color cubic-bezier(.25, .1, .25, 1), 300ms color cubic-bezier(.25, .1, .25, 1), 300ms border cubic-bezier(.25, .1, .25, 1);
  width: 100%;
  max-width: ${vw(321, 'mobile')};
  ${mq.greaterThan('tablet')}{
    border-radius: ${vw(20, 'desktop')};
    height: ${vw(40, 'desktop')};
    margin-bottom: ${vw(60, 'desktop')};
    max-width: ${vw(321, 'desktop')};
  }

  &:hover {
    background-color: ${rgbAlpha('--color-black', .7)} ;
    border: 1px solid  ${rgbAlpha('--color-black', .0)} ;
    color: var(--color-white);
  }

  &.active {
    background-color: ${rgbAlpha('--color-black', .4)} ;
    border: 1px solid  ${rgbAlpha('--color-black', .0)} ;
  }
`

const Input = styled.input`
  opacity: 0;
  width: 0;
`

const Label = styled.label`
  ${getP18()}
  cursor: pointer;
  display: block;
  text-align: center;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 ${vw(93, 'mobile')};

  ${mq.greaterThan('tablet')}{
    padding: 0 ${vw(93, 'desktop')};
  }
`
